import React, { useState } from 'react'
import { createModelWorkspace, getApiErrorMessage } from '../api'

export default function CreateModelWorkspace({ onCreated, onCancel }) {
  const [name, setName] = useState('')
  const [platform, setPlatform] = useState('onlyfans')
  const [timezone, setTimezone] = useState(() => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [created, setCreated] = useState(null)
  const [requestId] = useState(() => crypto.randomUUID())

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      // A failed refresh after creation must never repeat the create request.
      const model = created || await createModelWorkspace({ name: name.trim(), platform, timezone: timezone.trim(), request_id: requestId })
      setCreated(model)
      await onCreated(model)
    } catch (err) {
      setError(getApiErrorMessage(err, 'Could not complete setup. Refresh the model list before trying again.'))
    } finally { setBusy(false) }
  }

  return <article className="v2-config-card">
    <h3>Add a new model</h3>
    <p>Create the workspace first, then connect the selected platform. No messages will be sent; live automation stays paused.</p>
    {error ? <div className="v2-error" role="alert">{error}</div> : null}
    <form className="v2-form-grid" onSubmit={submit}>
      <label className="v2-field"><span>Model name</span><input required maxLength={120} value={name} disabled={busy || !!created} onChange={(event) => setName(event.target.value)} /></label>
      <label className="v2-field"><span>Platform</span><select value={platform} disabled={busy || !!created} onChange={(event) => setPlatform(event.target.value)}><option value="onlyfans">OnlyFans</option><option value="fansly">Fansly</option><option value="fanvue">Fanvue</option></select></label>
      <label className="v2-field"><span>Creator timezone</span><input required value={timezone} disabled={busy || !!created} onChange={(event) => setTimezone(event.target.value)} placeholder="America/New_York" /></label>
      <p className="v2-field-wide">{platform === 'fanvue' ? 'Fanvue uses OAuth in the next step. No OnlyFansAPI key is needed.' : platform === 'fansly' ? 'Choose and validate the Fansly account in the next step.' : 'Choose OnlyFansAPI or OnlyMonster in the next step.'}</p>
      <div className="v2-toolbar"><button type="submit" className="v2-btn v2-btn-primary" disabled={busy || !name.trim() || !timezone.trim()}>{busy ? 'Creating...' : created ? 'Continue to setup' : 'Create & start onboarding'}</button>{onCancel ? <button type="button" className="v2-btn v2-btn-secondary" disabled={busy} onClick={onCancel}>Cancel</button> : null}</div>
    </form>
  </article>
}
